import React, { useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { QRCodeCanvas } from 'qrcode.react';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { SubTitle } from 'components/SubTitle/SubTitle';

import './EventOnlineQrCode.scss';

const QR_SIZE = 200;

export const EventOnlineQrCode = ({ url }) => {
  const [copied, setCopied] = useState(false);
  const canvasRef = useRef(null);

  const handleCopy = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleDownload = () => {
    const canvas = canvasRef.current?.querySelector('canvas');
    if (!canvas) return;
    const dataUrl = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = 'event-qr-code.png';
    link.click();
  };

  return (
    <div className="event-online-qr-code">
      <SubTitle text="QR Code – Online-Veranstaltung Teilnahme" notFramed />
      <div className="event-online-qr-code__canvas-wrapper" ref={canvasRef}>
        <QRCodeCanvas value={url} size={QR_SIZE} level="M" />
      </div>
      <div className="event-online-qr-code__link-row">
        <span className="event-online-qr-code__link-text" title={url}>
          {url}
        </span>
        <ActionButton
          inverted
          type="button"
          title={copied ? 'Kopiert!' : 'Link kopieren'}
          onClick={handleCopy}
        />
        <ActionButton type="button" title="QR Code herunterladen" onClick={handleDownload} />
      </div>
    </div>
  );
};

EventOnlineQrCode.propTypes = {
  url: PropTypes.string.isRequired,
};
